"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SmallSteeringWheel.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SmallSteeringWheel = function SmallSteeringWheel(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 18.62 18.62"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Small Steering Wheel Icon"), _react2.default.createElement("path", {
    className: "steering-wheel",
    d: "M10,0a9.31,9.31,0,1,0,9.31,9.31A9.31,9.31,0,0,0,10,0Zm0,17.13A7.82,7.82,0,0,1,8.52,17a11.49,11.49,0,0,0-.22-2.57h3.52a11.47,11.47,0,0,0-.2,2.57A7.82,7.82,0,0,1,10,17.13ZM2.19,9.56c1.47,0.27,5.3,1.52,5.3,7.15A7.83,7.83,0,0,1,2.19,9.56ZM10,1.48a7.82,7.82,0,0,1,6.74,3.87A30.68,30.68,0,0,0,3.37,5.16,7.82,7.82,0,0,1,10,1.48Zm7.79,7.07a8.24,8.24,0,0,0-1.5.44L13.66,5.82a28,28,0,0,1,3.66.74A7.75,7.75,0,0,1,17.79,8.55Zm-2.45.9a7,7,0,0,0-3.22,3.93H8A7,7,0,0,0,5,9.6l3.32-4a30.45,30.45,0,0,1,3.82.07ZM6.95,5.68L4.11,9.11a8.18,8.18,0,0,0-1.89-.58,7.76,7.76,0,0,1,.54-2.16A26.69,26.69,0,0,1,6.95,5.68Zm5.7,11c0-5.41,3.6-6.75,5.16-7.07a7.83,7.83,0,0,1-5.16,7v0Z",
    transform: "translate(-0.69)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = SmallSteeringWheel;